import styled from 'styled-components';

export default styled.img`
  height: 100%;
  width: 100%;
`;
